export interface IGetUserResponse {
    isAuthenticated: boolean;
    claims?: IUserClaim[];
}

export type User = {
    isAuthenticated: boolean;
    profile: Profile
}

interface IUserClaim {
    type: string;
    value: string;
}

export function mapUserClaims(userObject: { [key: string]: any }, claims: IUserClaim[]) {
    claims.forEach((claim) => {
        userObject[claim.type] = claim.value;
    });
};

export type Profile = IDTokenClaims & ProfileStandardClaims;

interface IDTokenClaims {
    /** Issuer Identifier */
    iss?: string;
    /** Subject identifier */
    sub?: string;
    /** Audience(s): client_id ... */
    aud?: string;
    /** Expiration time */
    exp?: number;
    /** Issued at */
    iat?: number;
    /** Time when the End-User authentication occurred */
    auth_time?: number;
    /** Time when the End-User authentication occurred */
    nonce?: number;
    /** Access Token hash value */
    at_hash?: string;
    /** Authentication Context Class Reference */
    acr?: string;
    /** Authentication Methods References */
    amr?: string[];
    /** Authorized Party - the party to which the ID Token was issued */
    azp?: string;
    /** Session ID - String identifier for a Session */
    sid?: string;

    /** Other custom claims */
    [claimKey: string]: any;
}

interface ProfileStandardClaims {
    /** End-User's full name */
    name?: string;
    /** Given name(s) or first name(s) of the End-User */
    given_name?: string;
    /** Surname(s) or last name(s) of the End-User */
    family_name?: string;
    /** Middle name(s) of the End-User */
    middle_name?: string;
    /** Casual name of the End-User that may or may not be the same as the given_name. */
    nickname?: string;
    /** Shorthand name that the End-User wishes to be referred to at the RP, such as janedoe or j.doe. */
    preferred_username?: string;
    /** URL of the End-User's profile page */
    profile?: string;
    /** URL of the End-User's profile picture */
    picture?: string;
    /** URL of the End-User's Web page or blog */
    website?: string;
    /** End-User's preferred e-mail address */
    email?: string;
}